import { Component, OnInit } from "@angular/core";
import { Azienda } from "../models/Azienda";
import { ApiPathsService } from "../../api-paths.service";
import { data } from "jquery";
import { getClientRect } from "ngx-bootstrap/positioning/utils";
import { CampoUtility } from "src/app/shared/models/campo-aggiuntivo";
import { debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
import { DatePipe } from "@angular/common";

@Component({
  templateUrl: 'monitoraggio.component.html',
  // styleUrls: ['./monitoraggio.component.scss'],
})
export class MonitoraggioComponent implements OnInit {
  Presenze: any[];
  Clienti: Azienda[];
  private inputEventSubject: Subject<Event> = new Subject();
  constructor(private api: ApiPathsService, public campoUtility: CampoUtility, private datepipe: DatePipe) {
  }
  filtro: any = {};
  ngOnInit() {
    this.filtro.inizio = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.filtro.fine = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.Refresh();
    this.inputEventSubject.pipe(
      debounceTime(500)
    ).subscribe(event => {
      this.handleDebouncedInput(event);
    });
  }
  handleDebouncedInput(event: Event): void {
    this.Refresh();
  }
  onInput(event: Event): void {
    this.inputEventSubject.next(event);
  }


  Refresh() {
    this.api.ClassicPost('/anagrafica/clienti/list', { page: 0, size: 10, ruolo: 'C', inseriti: true, nome: this.filtro.ospite }).subscribe(data => {
      this.Clienti = data.data;
      this.api.ClassicPost('/task/task/list', { page: 0, size: 10, tipo: 'P', periodo: this.filtro.inizio && this.filtro.fine ? true : false, inizio: this.filtro.inizio, fine: this.filtro.fine, }).subscribe((response: { data: any[], total: number }) => {
        var dummy = [];
        response.data?.forEach(presenza => {
          var val = dummy.find(x => x.data_inizio_prevista?.slice(0, 10) == presenza.data_inizio_prevista.slice(0, 10))
          if (val) {
            var existing = val.esiti.find(x => x.cliente == presenza.cliente);
            if (existing) {
              existing.id = presenza.id;
              existing.esiti = presenza.stato == 'P' ? (presenza.esiti ?? [0, 0, 0, 0, 0]) : null;
              existing.presenza = presenza;
            }
          }
          else {
            var newTask = Object.assign({}, presenza)
            newTask.esiti = [...this.Clienti.filter(x => x.id != presenza.cliente).map(x => { return { cliente: x.id, } }), ...[{ cliente: presenza.cliente, esiti: presenza.stato == 'P' ? (presenza.esiti ?? [0, 0, 0, 0, 0]) : null, id: presenza.id, presenza: presenza }]]
            dummy.push(newTask)
          }
        })
        //TODO: generare struttura [{campo,nome}]
        this.Presenze = dummy;
        console.log("Presenze: ", this.Presenze)
      });
    });
  }


  UpdatePresenze() {
    this.Presenze.forEach(colonna => {
      colonna.esiti.forEach((taskClienti: { id, esiti, presenza }) => {
        var task = Object.assign({}, taskClienti.presenza);
        task.esiti = taskClienti.esiti;
        task.data_attivita = task.data_inizio_prevista;
        if (task.id)
          this.api.ClassicPost(`${this.campoUtility.getDynamicTaskSctructure('P')?.restRoute}/update`, task).subscribe()
      });

    })
  }
}
